<template>
  <Content class="col-span-full" :title="$route.name">
    <Form @result="result = $event" />

    <titleHolder :title="$t('MAX_SPEED')" v-if="result" />
    <div class="flex flex-col gap-8 mb-8" v-if="result">
      <VueApexCharts
        v-if="series1.length"
        type="line"
        height="450"
        :options="chartOptionsDefault"
        :series="series1"
      ></VueApexCharts>
    </div>
    <titleHolder :title="$t('AVG_SPEED')" v-if="result" />
    <div class="flex flex-col gap-8 mb-8" v-if="result">
      <VueApexCharts
        v-if="series2.length"
        type="line"
        height="450"
        :options="chartOptions"
        :series="series2"
      ></VueApexCharts>
    </div>
    <titleHolder :title="$t('ODOMETER')" v-if="result" />
    <div class="flex flex-col gap-8 mb-8" v-if="result">
      <VueApexCharts
        v-if="series3.length"
        type="line"
        height="450"
        :options="chartOptions"
        :series="series3"
      ></VueApexCharts>
    </div>
    <titleHolder :title="$t('Amount_of_work_perday')" v-if="result" />
    <div class="flex flex-col gap-8 mb-8" v-if="result">
      <VueApexCharts
        v-if="series7.length"
        type="line"
        height="450"
        :options="chartOptions"
        :series="series7"
      ></VueApexCharts>
    </div>
    <titleHolder :title="$t('acceleration')" v-if="result" />
    <div class="flex flex-col gap-8 mb-8" v-if="result">
      <VueApexCharts
        v-if="series4.length"
        type="line"
        height="450"
        :options="chartOptions"
        :series="series4"
      ></VueApexCharts>
    </div>
    <titleHolder :title="$t('braking')" v-if="result" />
    <div class="flex flex-col gap-8 mb-8" v-if="result">
      <VueApexCharts
        v-if="series5.length"
        type="line"
        height="450"
        :options="chartOptions"
        :series="series5"
      ></VueApexCharts>
    </div>
    <titleHolder :title="$t('cornering')" v-if="result" />
    <div class="flex flex-col gap-8 mb-8" v-if="result">
      <VueApexCharts
        v-if="series6.length"
        type="line"
        height="450"
        :options="chartOptions"
        :series="series6"
      ></VueApexCharts>
    </div>

    <titleHolder
      :title="$t('max_temperature')"
      v-if="result && hasMaxTemperature"
    />
    <div class="flex flex-col gap-8 mb-8" v-if="result && hasMaxTemperature">
      <VueApexCharts
        v-if="series8.length"
        type="line"
        height="450"
        :options="chartOptions"
        :series="series8"
      ></VueApexCharts>
    </div>

    <titleHolder
      :title="$t('mean_temperature')"
      v-if="result && hasMeanTemperature"
    />
    <div class="flex flex-col gap-8 mb-8" v-if="result && hasMeanTemperature">
      <VueApexCharts
        v-if="series9.length"
        type="line"
        height="450"
        :options="chartOptions"
        :series="series9"
      ></VueApexCharts>
    </div>

    <titleHolder
      :title="$t('min_temperature')"
      v-if="result && hasMinTemperature"
    />
    <div class="flex flex-col gap-8 mb-8" v-if="result && hasMinTemperature">
      <VueApexCharts
        v-if="series10.length"
        type="line"
        height="450"
        :options="chartOptions"
        :series="series10"
      ></VueApexCharts>
    </div>
  </Content>
</template>

<script>
import Form from "./components/form";
import VueApexCharts from "vue-apexcharts";
import titleHolder from "@/components/elements/title.vue";
import { gregorianToJalali } from "@/mixins/gregorianToJalali";
import { licenseChars } from "@/api/global";
import { License } from "@/mixins/License";

export default {
  mixins: [gregorianToJalali, License],
  data() {
    return {
      result: null,
      alphaList: [
        {
          char: "",
          code: "",
        },
      ],
      series1: [],
      series2: [],
      series3: [],
      series4: [],
      series5: [],
      series6: [],
      series7: [],
      series8: [], // for max temperature
      series9: [], // for mean temperature
      series10: [],
      hasMaxTemperature: false,
      hasMeanTemperature: false,
      hasMinTemperature: false,
      chartOptions: {
        chart: {
          height: 450,
          type: "line",
          toolbar: { show: true },
        },
        stroke: {
          curve: "smooth",
          width: 2,
        },
        markers: {
          size: 4,
        },
        xaxis: {
          labels: {
            show: false,
          },
        },
        yaxis: {
          title: {
            text: "",
          },
        },
        tooltip: {
          shared: true,
          intersect: false,
          x: {
            formatter: (val, opts) => {
              const index = opts.dataPointIndex;
              return this.chartOptionsDefault.xaxis.categories[index];
            },
          },
        },
        dataLabels: { enabled: false },
        grid: { row: { colors: ["#fff", "#f2f2f2"] } },
        fill: {
          colors: ["#008FFB"], // Default color
        },
      },
      chartOptionsDefault: {
        chart: {
          height: 450,
          type: "line",
          toolbar: { show: true },
        },
        stroke: {
          curve: "smooth",
          width: 2,
        },
        markers: {
          size: 4,
        },
        xaxis: {
          labels: {
            show: false,
          },
        },
        yaxis: {
          title: {
            text: "",
          },
        },
        tooltip: {
          shared: true,
          intersect: false,
          x: {
            formatter: (val, opts) => {
              const index = opts.dataPointIndex;
              return this.chartOptionsDefault.xaxis.categories[index];
            },
          },
        },
        dataLabels: { enabled: false },
        grid: { row: { colors: ["#fff", "#f2f2f2"] } },
        fill: {
          colors: ["#008FFB"], // Default color
        },
        annotations: {
          yaxis: [
            {
              y: 100,
              borderColor: "red",
              label: {
                borderColor: "red",
                style: {
                  color: "#fff",
                  background: "red",
                },
                text: "",
              },
            },
          ],
        },
      },

      resultCount: 0,
      chartWidth: "",
    };
  },
  components: {
    Form,
    VueApexCharts,
    titleHolder,
  },
  methods: {
    updateChartOptions() {
      this.chartWidth = this.resultCount > 10 ? 4000 : "100%";
    },
    handleResize() {
      this.updateChartOptions();
    },
  },
  mounted() {
    licenseChars.api().then((res) => {
      this.alphaList = res;
    });
  },
  watch: {
    result(val) {
      if (!val) {
        this.series1 = [];
        this.series2 = [];
        this.series3 = [];
        this.series4 = [];
        this.series5 = [];
        this.series6 = [];
        this.series7 = [];
        this.series8 = [];
        this.series9 = [];
        this.series10 = [];
        this.hasMaxTemperature = false;
        this.hasMeanTemperature = false;
        this.hasMinTemperature = false;
        this.chartOptionsDefault.xaxis.categories = [];
      } else {
        // Create a unique list of dates (for maintaining order consistency)
        const uniqueDates = Array.from(
          new Set(val.map((item) => this.gregorianToJalali(item.date)))
        );

        // Group data by license_plate
        const groupedByLicensePlate = val.reduce((acc, item) => {
          const plate = item.company_vehicle.license_plate || "Unknown";
          if (!acc[plate]) {
            acc[plate] = [];
          }
          acc[plate].push(item);
          return acc;
        }, {});

        const hasMaxTemp = val.some((item) => item.max_temperature !== null);
        const hasMeanTemp = val.some((item) => item.mean_temperature !== null);
        const hasMinTemp = val.some((item) => item.min_temperature !== null);

        this.hasMaxTemperature = hasMaxTemp;
        this.hasMeanTemperature = hasMeanTemp;
        this.hasMinTemperature = hasMinTemp;

        // Initialize series data to include placeholders for all dates
        const createSeriesData = (metricCallback) => {
          return Object.entries(groupedByLicensePlate).map(
            ([plate, records]) => {
              // Create a date-mapped object for all dates
              const dateMap = uniqueDates.reduce((map, date) => {
                map[date] = null; // Placeholder for missing data
                return map;
              }, {});

              // Populate the dateMap with available data for the current plate
              records.forEach((record) => {
                const jalaliDate = this.gregorianToJalali(record.date);
                dateMap[jalaliDate] = metricCallback(record);
              });

              // Return the series object with data in date order
              return {
                name: this.License(plate, this.alphaList),
                data: uniqueDates.map((date) => dateMap[date] ?? 0), // Default to 0 if data is missing
              };
            }
          );
        };

        // For reference: All dates in Jalali format
        let test = uniqueDates;

        // Update result count and chart width
        this.resultCount = val.length;
        this.chartWidth = this.resultCount > 15 ? 4000 : "100%";

        // Series for different metrics
        this.series1 = createSeriesData((i) => i.max_speed);
        this.series2 = createSeriesData((i) => i.mean_speed);
        this.series3 = createSeriesData((i) =>
          Math.ceil(i.traveled_distance / 1000)
        );
        this.series4 = createSeriesData((i) => i.number_of_harsh_acceleration);
        this.series5 = createSeriesData((i) => i.number_of_harsh_braking);
        this.series6 = createSeriesData((i) => i.number_of_harsh_cornering);
        this.series7 = createSeriesData((i) => (i.work_time / 60).toFixed(1));
        if (hasMaxTemp) {
          this.series8 = createSeriesData((i) => i.max_temperature);
        }
        if (hasMeanTemp) {
          this.series9 = createSeriesData((i) => i.mean_temperature);
        }
        if (hasMinTemp) {
          this.series10 = createSeriesData((i) => i.min_temperature);
        }

        this.updateChartOptions();
        this.chartOptionsDefault.xaxis.categories = test;
      }
    },
  },
};
</script>
